import { Component, OnInit, Renderer2, ChangeDetectorRef } from "@angular/core";
import { environment } from "../../../../environments/environment";
import { Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { TCCPCommonService } from "../../services/tccp-common.service";
import { TCCPLocalStorageService } from "../../services/tccp-local-storage.service";
import { BreadcrumbService } from "../breadcrumb/breadcrumb.service";
import { LoaderService } from "../../loader/loader.service";
import { Gtag } from "angular-gtag";
import { MatDialog } from "@angular/material/dialog";
import { PhoneManufacturerService } from "../phone-manufacturer/phone-manufacturer.service";
import { TCCPConstantValues } from "src/modules/shared/models/tccp-constants";
import { ConfirmModalComponent } from "../confirm-modal/confirm-modal.component";
import * as _ from "lodash";
import { PhoneCompatabilityService } from "../phone-compatability/phone-compatability.service";
import { MsalService } from "@azure/msal-angular";

@Component({
  selector: "app-bt-compatability",
  templateUrl: "./bt-compatability.component.html",
  styleUrls: ["./bt-compatability.component.scss"],
})
export class BtCompatabilityComponent implements OnInit {
  public envName = "";
  public isInternal = false;
  public windowWidth = window.innerWidth;
  public appName = environment.applicationName;
  public searchForm: FormGroup;
  public routerPath = "";
  public hasFocus = false;
  public vehicleYear = [];
  public vehicleModel = [];
  public btVehicleModels = [];
  public isSubmitted = false;
  public showError = false;
  public vinOptions: string[] = [];
  public vinError = false;
  public vinNotAvalibaleError = false;
  public vinYearNotAvalibaleError = false;
  public modelCodeInfo: string = null;
  public featureType: string = null;
  public vinInOtherDivisionError = false;
  public resultLink = "";
  public hideSelectionSection = false;
  public selectedVehicleModelName: any;
  public disableSearchButton = false;
  public isSearchButtonSubmitted = false;
  public phoneManufacturerList = [];
  public phoneModelList = [];
  public manufaturerForm: FormGroup;
  public huConfigList: number[] = [];
  public phoneModelWithHUCofigList = [];
  public selectedPhoneConfigId: any;
  public phoneHUConfigInfoList = [];
  public vin = "";
  public telematicsMPC = "";
  public vehicleOpenState = true;
  public compatabilityOpenState = false;
  public showPhoneCompatabilityError = false;
  public btVehicleYears = [];
  public modelToYearMap = new Map();
  public resultData: any;
  public BtAppName: any;

  readonly homeURL =
    this.storageService.getFeatureType() === "internal"
      ? `${this.appName}/home/internal`
      : `${this.appName}/home`;

  constructor(
    readonly router: Router,
    readonly fb: FormBuilder,
    readonly breadcrumbService: BreadcrumbService,
    public commonService: TCCPCommonService,
    readonly storageService: TCCPLocalStorageService,
    readonly loaderService: LoaderService,
    public authService: MsalService,
    readonly gtag: Gtag,
    readonly renderer: Renderer2,
    readonly dialog: MatDialog,
    public cdRef: ChangeDetectorRef,
    private phoneManufacturerService: PhoneManufacturerService,
    private phoneCompatabilityService: PhoneCompatabilityService
  ) {
    this.commonService.hideModelYearSection.emit(false);
    this.vinOptions = this.storageService.getVinAutoSuggesstion()[this.appName];
    if (this.vinOptions) {
      this.vinOptions.reverse();
    }
    this.commonService.hideModelYearSection.emit(false);
    this.commonService.clearHomePage.subscribe(
      (data) => {
        const vinKey = "vin";
        const nameKey = "name";

        let enteredVIN = this.storageService.getVin();
        if (typeof enteredVIN === "object") {
          enteredVIN = enteredVIN && enteredVIN[nameKey];
        }
        if (data === "MODEL") {
          if (enteredVIN) {
            this.searchForm.patchValue({
              model: "",
              year: "",
              vin: enteredVIN,
            });
          }
          this.vehicleYear = [];
          this.btVehicleYears = [];
          this.onModelChange();
          this.searchForm.controls.vin.setValue(enteredVIN);
          const vehicleYear =
            this.storageService.getVehicleYear() &&
            this.storageService.getVehicleYear().name;
          if (!vehicleYear) {
            this.storageService.setVehicleYear(null, null);
          } else {
            this.storageService.setVehicleYear(
              Number(vehicleYear),
              this.homeURL
            );
          }
          this.searchForm.patchValue({
            year: "",
          });
        } else if (data === "YEAR") {
          if (this.router.url.includes("internal")) {
            this.onModelChange();
          }
          if (enteredVIN) {
            this.searchForm.patchValue({
              model: "",
              year: "",
              vin: enteredVIN,
            });
          }
        } else if (data === vinKey) {
          if (this.router.url.includes("internal")) {
            this.onModelChange();
          }
          const vehicleVIN = this.storageService.getVehicleVin();
          if (vehicleVIN && vehicleVIN.name) {
            this.searchForm.controls.vin.setValue(vehicleVIN.name);
          }
        } else if (data === "HOME") {
          this.vehicleYear = [];
          this.btVehicleYears = [];
          this.searchForm.patchValue({
            model: "",
            year: "",
            vin: "",
          });
        }
      },
      (error) => {}
    );
  }

  focus() {
    this.hasFocus = true;
  }

  async getYearDetails(model): Promise<void> {
    await this.commonService.getYearDetails(model).then((data) => {
      if (data) {
        this.loaderService.hide();
        this.vehicleYear = data;
        const vYear = this.storageService.getVehicleYear();
        if (vYear && vYear.name) {
          this.searchForm.patchValue({
            year: vYear.name,
          });
        }
      }
    });
  }

  public onModelChange(event?) {
    this.searchForm.patchValue({
      vin: "",
    });
    this.clearAllErrors();
    this.compatabilityOpenState = false;
    this.isSubmitted = false;
    const vehicleModelName = this.searchForm.get("model").value;
    if (_.isNil(vehicleModelName)) {
      this.storageService.setVehicleModelName(null);
    }
    this.storageService.setBtVehicleModelName(vehicleModelName);
    const btVehicleModelName = this.searchForm.get("model").value;
    this.setBTVehicleYearList(btVehicleModelName);
    this.selectedVehicleModelName = vehicleModelName;
  }

  setBTVehicleYearList(btVehicleModelName) {
    this.btVehicleYears = this.modelToYearMap.get(btVehicleModelName);
    this.btVehicleYears = _.sortBy(this.btVehicleYears).reverse();
    if (this.btVehicleYears.length === 0) {
      this.btVehicleModels = this.btVehicleModels.filter(
        (mData) => mData.name !== btVehicleModelName
      );
    }
    if (this.btVehicleYears) {
      this.searchForm.patchValue({
        year: "",
      });
    }
  }

  ngOnInit() {
    this.BtAppName = this.appName === "toyota" ? "toyota" : "lexus";
    this.storageService.setVehicleYear(Number(null), null);
    this.storageService.setBtVehicleYear(Number(null), null);
    this.storageService.setBtVehicleModelName("");
    this.storageService.setBtVehicleModel(null, null);
    this.storageService.setVehicleModel(null, null);
    this.storageService.setBtMPCCode(null);
    this.envName = window.location.href;
    this.commonService.hideBreadrumb.emit(false);
    this.commonService.hideModelYearSection.emit(true);
    this.breadcrumbService.clearBreadcrumb.emit(true);
    this.breadcrumbService.showBreadcrumb.emit(false);
    this.isInternal = this.envName.includes("internal");
    this.routerPath = `${this.appName}/home`;
    this.hideSelectionSection = false;
    this.commonService.hideModelYearSection.subscribe((flag) => {
      this.hideSelectionSection = flag;
    });
    this.featureType = this.storageService.getFeatureType();
    this.vinOptions = this.storageService.getVinAutoSuggesstion()[this.appName];
    if (this.vinOptions) {
      this.vinOptions.reverse();
    }
    this.commonService.enableFeedback = false;
    this.storageService.setMPCCode(null);
    this.commonService.showFeedback.emit({ showFeedback: false });
    environment.applicationName = this.appName;
    this.storageService.setHome(`${this.appName}/home/${this.featureType}`);
    this.commonService.setGTagPageDetails(
      "Home",
      `${this.appName}/home`,
      window.location.href
    );
    this.isInternal = false;
    this.storageService.setHome(this.homeURL); // change
    this.isInternal = this.commonService.setAppFeatureType(this.router.url);
    const vinCharacterPattern = "^[a-zA-Z0-9]*$";
    this.commonService.landingPage = true;
    this.searchForm = this.fb.group({
      model: ["", Validators.required],
      year: ["", Validators.required],
      vin: [
        "",
        [
          Validators.required,
          Validators.pattern(vinCharacterPattern),
          Validators.minLength(17),
          Validators.maxLength(17),
        ],
      ],
    });
    const vehicleVIN =
      this.storageService.getVin() && this.storageService.getVehicleVin().name;
    let vehicleModel = this.storageService.getVehicleModel();
    let vehicleYear =
      this.storageService.getVehicleYear() &&
      this.storageService.getVehicleYear().name;
    this.storageService.clearFlow();
    this.loaderService.show();
    if (vehicleVIN) {
      const appURl = window.location.href;

      this.storageService.setVehicleModel(null, null);
      this.storageService.setVehicleYear(null, null);
      this.storageService.setBtVehicleYear(null, null);
      this.storageService.setVehicleModelName(null);
      vehicleModel = this.storageService.getVehicleModel();
      vehicleYear =
        this.storageService.getVehicleYear() &&
        this.storageService.getVehicleYear().name;

      this.searchForm.patchValue({
        model: "",
        year: "",
        vin: "",
      });
    }
    this.commonService.getModel().subscribe(
      (data) => {
        if (data) {
          this.btVehicleModels = data;
          this.btVehicleModels.forEach(
            (model) => {
              let vYears = model.years;
              let modelYears = [];
              vYears.forEach((year) => {
                modelYears.push(year.year);
              });
              modelYears = modelYears.map(String);
              //map of models to years
              this.modelToYearMap.set(model.model, modelYears);
              const transformedData = Array.from(this.modelToYearMap.entries())
                .filter(([model, years]) => years.length > 0) // Filter out models with no years
                .map(([model, years]) => ({
                  model: model, // Model name
                  years: years, // Corresponding years
                }));
              this.btVehicleModels = transformedData;
              this.storageService.setBtModels(transformedData);
              this.loaderService.hide();
            },
            (error) => {
              this.loaderService.hide();
            }
          );

          this.storageService.setBtModels(this.btVehicleModels);
          if (!this.isInternal) {
            for (let i = data.length - 1; i > -1; i--) {
              if (data[i].model.toUpperCase().includes("SUBARU")) {
                data.splice(i, 1);
              }
            }
          }
          this.loaderService.hide();
          this.vehicleModel = data;
          this.vehicleModel.sort((a, b) => {
            return a.model.localeCompare(b.model, "en", {
              sensitivity: "base",
            });
          });
          this.storageService.setModels(data);
          if (vehicleModel && vehicleModel.name) {
            this.searchForm.patchValue({
              model: vehicleModel.name,
            });
            this.onModelChange();
            if (!vehicleYear) {
              this.storageService.setVehicleYear(null, null);
              this.storageService.setBtVehicleYear(null, null);
            } else {
              this.storageService.setVehicleYear(
                Number(vehicleYear),
                this.homeURL
              );
              this.storageService.setBtVehicleYear(
                Number(vehicleYear),
                this.homeURL
              );
            }
          } else {
            if (!vehicleYear) {
              this.vehicleYear = [];
              this.btVehicleYears = [];
              this.searchForm.patchValue({
                model: "",
                year: "",
              });
            }
          }
        }
      },
      (error) => {
        this.loaderService.hide();
      }
    );

    this.commonService.setBackground(this.renderer, this.appName);

    this.manufaturerForm = this.fb.group({
      manufaturer: ["", Validators.required],
      phoneModel: ["", Validators.required],
    });
  }

  showDisclaimer() {
    const disclaimerText =
      TCCPConstantValues[this.appName].FIXED_VALUES.MANUFACTURER_DISCLAIMER;
    const temp =
      this.windowWidth < 420 && this.windowWidth > 405 ? "63vw" : "auto";
    this.dialog.open(ConfirmModalComponent, {
      height: temp,
      data: { type: "basic", message: disclaimerText },
    });
  }

  getPhoneManufaturerList(vin: string) {
    this.phoneModelWithHUCofigList = null;
    const requestData = this.commonService.getBtPayload(this.huConfigList, vin);
    this.loaderService.show();
    if (this.resultData) {
      if (_.get(this.resultData, "title") === "Data Exception") {
        this.setError();
      } else {
        if (this.resultData.data.headUnits) {
          this.resultData.data.headUnits.forEach((data, index) => {
            if (!_.isEmpty(vin)) {
              this.telematicsMPC = requestData.mpc ? requestData.mpc : "";
              this.storageService.setTelematicsMPCCode(this.telematicsMPC);
            }
          });
          this.phoneManufacturerService
            .getManufaturerList(this.huConfigList)
            .subscribe(
              (data) => {
                if (data) {
                  this.phoneModelWithHUCofigList = data.data;
                  this.loaderService.hide();
                  this.phoneManufacturerList =
                    data.data["headUnits"][0]["manufacturers"];
                }
              },
              (error) => {
                this.loaderService.hide();
              }
            );
        }
      }
    }

    this.storageService.setHeadUnitConfigList(this.huConfigList);
  }

  public setCVSResponse(cvsResponse: any) {
    this.storageService.setVehicleModelYear(null);
    this.isSubmitted = true;
    this.isSearchButtonSubmitted = true;
    this.openDashBoard();
  }

  clearAllErrors() {
    this.vinError = false;
    this.showError = false;
    this.vinNotAvalibaleError = false;
    this.vinYearNotAvalibaleError = false;
    this.vinInOtherDivisionError = false;
    this.showPhoneCompatabilityError = false;
  }

  onVinSelected(value) {
    this.commonService.startLoaderEmitter.emit(true);
  }

  openDashBoard() {
    this.commonService.startLoaderEmitter.emit(true);
    this.isSubmitted = true;
    if (
      (this.searchForm.valid && this.isSubmitted) ||
      (this.vinInOtherDivisionError && this.isSubmitted)
    ) {
      if (
        this.searchForm.controls.vin.value &&
        this.searchForm.controls.vin.value !== ""
      ) {
        this.storageService.setVin(this.searchForm.controls.vin.value);
        const url =
          this.featureType === "internal"
            ? `${this.appName}/home/internal`
            : `${this.appName}/home`;
        this.storageService.setVehicleVin(
          this.searchForm.controls.vin.value,
          url
        );
      }
      let vinAutoSuggesstion = [];
      vinAutoSuggesstion = this.storageService.getVinAutoSuggesstion()
        ? this.storageService.getVinAutoSuggesstion()[this.appName]
        : null;
      if (vinAutoSuggesstion && vinAutoSuggesstion.length > 4) {
        vinAutoSuggesstion.shift();
      }
      if (
        vinAutoSuggesstion &&
        vinAutoSuggesstion.indexOf(this.searchForm.controls.vin.value) === -1
      ) {
        if (this.searchForm.controls.vin.value !== "") {
          vinAutoSuggesstion.push(this.searchForm.controls.vin.value);
          const autoSuggestion = {};
          autoSuggestion[this.appName] = vinAutoSuggesstion;
          this.storageService.setVinAutoSuggesstion(autoSuggestion);
        }
      }
      if (vinAutoSuggesstion === undefined) {
        if (this.searchForm.controls.vin.value !== "") {
          vinAutoSuggesstion = [];
          vinAutoSuggesstion.push(this.searchForm.controls.vin.value);
          const autoSuggestion = {};
          autoSuggestion[this.appName] = vinAutoSuggesstion;
          this.storageService.setVinAutoSuggesstion(autoSuggestion);
        }
      }
      this.disableSearchButton = false;
      this.getHUList();
      this.loaderService.hide();
    }
  }

  public onSearch() {
    this.huConfigList = [];
    this.isSearchButtonSubmitted = true;
    this.disableSearchButton = true;
    //this.commonService.startLoaderEmitter.emit(true);
    this.clearAllErrors();
    const vinKey = "vin";
    const yearKey = "year";
    const modelKey = "model";
    this.vinError = false;
    this.isSubmitted = true;
    this.showError = true;
    if (
      this.searchForm.controls.model.value &&
      this.searchForm.controls.year.value &&
      this.searchForm.controls.vin.value &&
      this.searchForm.controls.model.value === "" &&
      this.searchForm.controls.year.value === "" &&
      this.searchForm.controls[vinKey].value === ""
    ) {
      this.showError = true;
      this.isSearchButtonSubmitted = false;
      this.disableSearchButton = false;
    } else if (
      this.searchForm.controls.vin.value &&
      this.searchForm.controls.vin.value !== ""
    ) {
      if (
        this.searchForm.controls.vin.value.length === 17 &&
        !this.searchForm.get(vinKey).hasError("pattern")
      ) {
        const requestedVin = this.searchForm.controls.vin.value;
        const model = this.searchForm.get("model");
        const year = this.searchForm.get("year");
        this.storageService.setVin(requestedVin);
        this.storageService.setVehicleModel(null, null);
        this.storageService.setBtVehicleModel(null, null);
        this.storageService.setBtVehicleYear(null, null);
        this.storageService.setVehicleYear(null, null);
        const url =
          this.featureType === "internal"
            ? `${this.appName}/home/internal`
            : `${this.appName}/home`;
        this.storageService.setVehicleVin(requestedVin, url);
        this.searchForm.patchValue({
          model: "",
          year: "",
        });
        this.searchForm.controls[modelKey].setValue("");
        this.searchForm.controls[yearKey].setValue("");
        model.setValidators(null);
        model.updateValueAndValidity();
        year.setValidators(null);
        year.updateValueAndValidity();

        // Adding VIN based search
        this.vinError = false;
        this.isSearchButtonSubmitted = true;
        const vin = this.searchForm.get["vin"];
        this.commonService.getVehicleInfo(vin).subscribe((vinData) => {
          // this.loaderService.hide();

          if (vinData && vinData.summary) {
                this.storageService.setBtVehicleVin(vin);
                this.storageService.setBtSearchedByVin(true);
                this.storageService.setModelCode(
                  _.get(vinData, "summary.vehicleSummary.modelCode")
                );
                this.commonService.vinSummaryDetails = vinData;
                this.getPhoneManufaturerList(vin);
          }
        });

        if (!_.isNil(this.storageService.getVin())) {
          this.commonService
            .getVehicleInfo(this.storageService.getVehicleVin().name)
            .subscribe(async (vinData) => {
              this.showError = false;
              this.commonService.vinDetails = vinData;
              if (vinData.summary) {
                this.storageService.setVehicleGeneration(
                  vinData.summary.vehicleSummary.generation,
                  this.router.url
                );
                this.storageService.setBtModelCode(
                  _.get(vinData, "summary.vehicleSummary.modelCode")
                );
                this.storageService.setBtMPCCode(
                  _.get(vinData, "summary.vehicleSummary.mobilePlatformCode")
                );
                this.storageService.setBtVehicleYear(
                  _.get(vinData, "summary.vehicleSummary.modelYear"),
                  this.homeURL
                );
                this.storageService.setBtVehicleModelName(
                  _.get(vinData, "summary.vehicleSummary.modeldescription")
                );
                this.commonService.vinSummaryDetails = vinData;
                const modelYearFromVin = _.get(
                  vinData,
                  "summary.vehicleSummary.modelYear"
                );
                const brand: string = _.get(
                  vinData,
                  "summary.vehicleSummary.brand"
                );

                if (this.appName === "toyota") {
                  if (brand && brand !== "TOY") {
                    this.vinInOtherDivisionError = true;
                    this.resultLink =
                      await this.commonService.goToVinSearchResultLink(
                        this.searchForm.controls["vin"].value,
                        this.featureType
                      );
                    this.vinValidation();
                    return;
                  } else if (parseInt(modelYearFromVin, 10) < 2016) {
                    this.clearAllErrors();
                    this.vinYearNotAvalibaleError = true;
                    this.vinValidation();
                    return;
                  }
                }
                if (this.appName === "lexus") {
                  if (brand && brand !== "LEX") {
                    this.vinInOtherDivisionError = true;
                    this.resultLink =
                      await this.commonService.goToVinSearchResultLink(
                        this.searchForm.controls["vin"].value,
                        this.featureType
                      );
                    this.vinValidation();
                    return;
                  } else if (parseInt(modelYearFromVin, 10) < 2016) {
                    this.clearAllErrors();
                    this.vinYearNotAvalibaleError = true;
                    this.vinValidation();
                    return;
                  }
                }
                this.setCVSResponse(vinData);
              } else {
                this.showError = true;
                this.setError();
                this.vinError = true;
                this.isSubmitted = false;
              }
            });
        }
        // VIN Search End
      } else {
        this.showError = true;
        this.isSubmitted = true;
      }
    } else if (
      this.searchForm.controls.model.value &&
      this.searchForm.controls.year.value
    ) {
      if (
        (this.searchForm.controls[modelKey].value !== "" &&
          this.searchForm.controls[yearKey].value === "") ||
        (this.searchForm.controls[modelKey].value !== "" &&
          this.searchForm.controls[yearKey].value !== "")
      ) {
        const vin = this.searchForm.get(vinKey);
        vin.setValue(null);
        this.searchForm.patchValue({
          vin: "",
        });
        vin.setValidators(null);
        vin.updateValueAndValidity();
        this.showError = true;
        this.disableSearchButton = false;
        this.isSearchButtonSubmitted = false;
        if (
          this.searchForm.controls[modelKey].value !== "" &&
          this.searchForm.controls[yearKey].value !== ""
        ) {
          this.storageService.setVin(null);
          this.storageService.setVehicleVin(null, null);
          this.openDashBoard();
        }
      }
    }
    this.loaderService.hide();
  }

  vinValidation() {
    this.isSubmitted = true;
    this.isSearchButtonSubmitted = false;
    this.storageService.setVehicleVin(null, null);
    this.storageService.setVin(null);
    this.storageService.setVehicleModel(null, null);
    this.storageService.setVehicleModelName(null);
    window.scroll(0, 0);
  }

  onVinKeyup(input) {
    this.isSubmitted = false;
    this.phoneModelList = [];
    // this.compatabilityOpenState = false;
    this.storageService.setModelCode(null);
    this.disableSearchButton = false;
    this.compatabilityOpenState = false;
    this.searchForm.patchValue({
      model: "",
      year: "",
    });
    this.clearAllErrors();
    if (input && input === "") {
      this.clearAllErrors();
      const model = this.searchForm.get("model");
      const year = this.searchForm.get("year");
      this.searchForm.patchValue({
        model: "",
        year: "",
      });
      model.setValidators([Validators.required]);
      model.updateValueAndValidity();
      year.setValidators([Validators.required]);
      year.updateValueAndValidity();
    }
  }

  ngAfterViewChecked() {
    this.commonService.landingPage = true;
    const hideModelYearSection = this.hideSelectionSection;
    if (hideModelYearSection !== this.hideSelectionSection) {
      this.hideSelectionSection = hideModelYearSection;
      this.cdRef.detectChanges();
    }
  }

  getTooltipContent() {
    return this.appName === "toyota" ? "toyota-vinToolTip" : "lexus-vinToolTip";
  }

  public onYearChange(event) {
    this.clearAllErrors();
    this.phoneModelList = [];
    this.isSubmitted = false;
    this.compatabilityOpenState = false;
    const isVinSearch = this.searchForm.get("vin").value === "" ? false : true;
    if (!isVinSearch) {
      this.commonService.onBtYearChange(event, this.searchForm, this.homeURL);
    } else {
      this.commonService.onYearChange(
        event,
        this.searchForm,
        this.selectedVehicleModelName,
        this.homeURL,
        this.router.url
      );
    }
  }

  onManufaturerChange(event?) {
    this.isSubmitted = false;
    this.phoneModelList = [];
    const manufaturerValue =
      event && event.target.value
        ? parseInt(event.target.value, 10)
        : event.target.value;
    this.phoneModelWithHUCofigList["headUnits"].forEach((data, index) => {
      data.manufacturers.forEach((manufacturersData) => {
        if (manufacturersData.manufacturerId === manufaturerValue) {
          this.storageService.setHeadUnitConfig(data.headUnitConfigId);
        }
      });
    });

    const manufacturerList = Object.assign(
      [],
      this.phoneModelWithHUCofigList["headUnits"]
    );
    const phoneList = [];
    manufacturerList.forEach((manufactureData, i) => {
      manufactureData["manufacturers"].forEach((data, index) => {
        if (data.manufacturerId === manufaturerValue) {
          data["phones"].forEach((el, pindex) => {
            if (phoneList && phoneList.length > 0) {
              if (phoneList.indexOf(el.phoneModelName) === -1) {
                this.phoneModelList.push(el);
                phoneList.push(el["phoneModelName"]);
              }
            } else {
              this.phoneModelList.push(el);
              phoneList.push(el["phoneModelName"]);
            }
          });
        }
      });
    });
  }

  onPhoneModelChange(event?) {
    this.isSubmitted = false;
    this.phoneManufacturerService.selectedPhoneData = [];
    const phoneModelValue =
      event && event.target.value
        ? parseInt(event.target.value, 10)
        : event.target.value;
    const manufacturerList = Object.assign(
      [],
      this.phoneModelWithHUCofigList["headUnits"]
    );
    this.phoneModelList.forEach((phoneData) => {
      if (phoneModelValue === phoneData.phoneConfigId) {
        this.selectedPhoneConfigId = phoneData;
      }
    });

    manufacturerList.forEach((manufactureData, i) => {
      manufactureData["manufacturers"].forEach((data, index) => {
        if (
          data.manufacturerId ==
          this.manufaturerForm.controls["manufaturer"].value
        ) {
          data["phones"].forEach((el, pindex) => {
            if (
              el["phoneModelName"] ===
              this.selectedPhoneConfigId["phoneModelName"]
            ) {
              const phoneJson = el;
              phoneJson["headUnitConfigId"] = manufactureData.headUnitConfigId;
              this.phoneManufacturerService.selectedPhoneData.push(phoneJson);
            }
          });
        }
      });
    });
    this.getHeadUnitInfo();
    this.checkMpCodeInStorage();
    this.storageService.setPhoneModel(this.selectedPhoneConfigId);
  }

  checkMpCodeInStorage() {
    if (!_.isEmpty(this.storageService.getVehicleVin().name)) {
      if (
        this.storageService.getBtMPCCode() !==
          this.storageService.getTelematicsMPCCode() ||
        _.isEmpty(this.storageService.getBtMPCCode()) ||
        _.isEmpty(this.storageService.getTelematicsMPCCode())
      ) {
        this.storageService.setShowDisclaimer(true);
      }
    }
  }

  openCompabiltyDashBoard() {
    this.storageService.setPhoneCompatabilityDirectLink(true);
    this.isSubmitted = true;
    if (this.manufaturerForm.valid) {
      this.router.navigate([
        this.appName + "/bluetooth-compatability",
        this.manufaturerForm.controls["manufaturer"].value,
        this.selectedPhoneConfigId.phoneConfigId,
      ]);
    }
  }

  public getHeadUnitInfo() {
    if (this.resultData) {
      this.phoneHUConfigInfoList = this.resultData.data;
      this.phoneHUConfigInfoList["headUnits"].forEach((huData, huIndex) => {
        this.phoneManufacturerService.selectedPhoneData.sort(function (a, b) {
          return a.phoneConfigId - b.phoneConfigId;
        });
        this.phoneManufacturerService.selectedPhoneData.forEach((phoneData) => {
          if (phoneData["headUnitConfigId"].includes(huData.huConfigId) > 0) {
            this.phoneHUConfigInfoList["headUnits"][huIndex]["phoneOsVersion"] =
              phoneData["phoneOsVersion"];
            this.phoneHUConfigInfoList["headUnits"][huIndex]["phoneOsType"] =
              phoneData["phoneOsType"];
            this.phoneHUConfigInfoList["headUnits"][huIndex]["phoneConfigId"] =
              phoneData["phoneConfigId"];
          }
        });
      });
      this.phoneHUConfigInfoList["headUnits"].forEach((huData, huIndex) => {
        if (!huData["phoneConfigId"]) {
          this.phoneHUConfigInfoList["headUnits"].splice(huIndex, 1);
        }
      });
      this.phoneManufacturerService.selectedHUPhoneConfigData =
        this.phoneHUConfigInfoList;
      this.storageService.setHuPhoneConfigInfoList(this.phoneHUConfigInfoList);
    } else {
      this.setError();
    }
  }

  setError() {
    this.storageService.setShowBluetoothComp(false);
    this.showPhoneCompatabilityError = true;
    this.compatabilityOpenState = false;
  }

  getHUList() {
    const year = this.storageService.getBtVehicleYear().name;
    let requestData;
    if (this.searchForm.get("vin").value === "") {
      requestData = this.phoneManufacturerService.getBtHUPayload(
        this.storageService.getBtVehicleModelName(),
        year
      );
    } else {
      requestData = this.phoneManufacturerService.getBtHUPayloadWithModelCode(
        this.storageService.getBtModelCode(),
        this.storageService.getBtVehicleModelName,
        this.storageService.getBtMPCCode(),
        year
      );
    }

    this.phoneManufacturerService
      .getHUConfigList(requestData)
      .subscribe((resultData) => {
        if (_.get(resultData, "data.headUnits")) {
          this.resultData = resultData;
          this.showPhoneCompatabilityError = false;
          this.compatabilityOpenState = true;
          resultData.data.headUnits.forEach((data, index) => {
            this.huConfigList.push(data.huConfigId);
          });
          this.getPhoneManufaturerList(
            this.storageService.getVehicleVin().name
          );
        } else {
          if (resultData.messages.includes("No data found for given request")) {
            this.setError();
          }
          this.compatabilityOpenState = false;
          this.showPhoneCompatabilityError = true;
        }
      });
  }
}
